import { useCallback } from 'react';
import {
	connectDataBoxQuery,
	useAxiosInstance,
	usePoMutation,
} from '@gov-nx/api';
import type { Nullable } from '@gov-nx/core/types';

export const useDataBoxConnect = () => {
	const { axiosInstance } = useAxiosInstance();

	const mutation = usePoMutation({
		mutationKey: ['data-box-connect'],
		mutationFn: connectDataBoxQuery(axiosInstance),
	});

	const connect = useCallback(
		async (sessionId: string): Promise<Nullable<string>> => {
			const dataBoxToAdd = { isDsRedirect: 'sessionId=' + sessionId };
			const body = { klic: JSON.stringify(dataBoxToAdd) };
			const response = await mutation.mutateAsync({
				dataBoxId: 'sessionId',
				body,
			});
			return response.data?.datovaSchrankaId;
		},
		[mutation]
	);

	return { connect };
};
